@if (!loading()) {
  <div
    [formGroup]="appointmentForm"
    class="flex flex-col"
  >
    <mat-form-field class="w-full">
      <mat-label>Партнер</mat-label>
      <mat-select [formControl]="fc.partnerName">
        @for (partner of allPartnersOptions(); track partner.id) {
          <mat-option
            [value]="partner.name"
            (click)="selectPartnerOption(partner.id)"
          >
            {{ partner.name }}
          </mat-option>
        }
      </mat-select>
      @if (fc.partnerName.invalid && fc.partnerName.touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Адреса надання послуги</mat-label>
      <mat-select [formControl]="fc.location">
        @for (location of allLocationsOptions(); track location.id) {
          <mat-option
            [value]="location.location.address"
            (click)="selectLocationOption(location.id)"
          >
            {{ location.name }} ({{ location.location.address }})
          </mat-option>
        }
      </mat-select>
      @if (fc.location.invalid && fc.location.touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Вартість послуги (грн)</mat-label>
      <input
        matInput
        type="number"
        min="0"
        step="0.01"
        [formControl]="fc.price"
      />
      @if (fc.price.invalid && fc.price.touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>ПІБ лікаря</mat-label>
      <input
        matInput
        type="text"
        [formControl]="fc.doctorName"
      />
      @if (fc.doctorName.invalid && fc.doctorName.touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <div class="flex w-full gap-4">
      <shared-datepicker
        class="flex-1"
        labelKey="appointments.label.date"
        [formControl]="fc.dateStart"
      />
      <mat-form-field class="flex-1">
        <mat-label>Час візиту</mat-label>
        <input
          matInput
          type="time"
          [formControl]="fc.time"
        />
        @if (fc.time.invalid && fc.time.touched) {
          <mat-error>Це обов'язкове поле</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="w-full pb-1">
      <mat-checkbox [formControl]="fc.appointmentCompletedFlag"> Візит завершено </mat-checkbox>
    </div>
  </div>
} @else {
  <div class="flex items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}
